/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Reseller_Pricing_Prices_TitleInputs */

const id_reseller_pricing_prices_title = /** @type {(inputs: Reseller_Pricing_Prices_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Harga jual ${i?.tld}`)
};

const en_reseller_pricing_prices_title = /** @type {(inputs: Reseller_Pricing_Prices_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selling prices for ${i?.tld}`)
};

/**
* | output |
* | --- |
* | "Selling prices for {tld}" |
*
* @param {Reseller_Pricing_Prices_TitleInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_prices_title = /** @type {((inputs: Reseller_Pricing_Prices_TitleInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Prices_TitleInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_prices_title(inputs)
	return id_reseller_pricing_prices_title(inputs)
});